import { NavLink, Outlet, Link } from 'react-router-dom';
import RequireStaff from '../../components/RequireStaff';

const MENU = [
  ['/admin', '📊 Tổng quan', true],
  ['/admin/orders', '🧾 Đơn hàng'],
  ['/admin/products', '📦 Sản phẩm & tồn kho'],
  ['/admin/combos', '🎁 Combo'],
  ['/admin/promotions', '🏷️ Khuyến mãi'],
  ['/admin/offers', '🎯 Mức offer'],
  ['/admin/content', '📝 Nội dung site'],
  ['/admin/social', '📣 Tương tác MXH'],
  ['/admin/docs', '📚 Hướng dẫn & script'],
  ['/admin/sale-push', '📉 Hàng cần đẩy sale'],
  ['/admin/shifts', '🗓️ Lịch làm việc'],
  ['/admin/attendance', '⏱️ Chấm công'],
  ['/admin/checklist', '✅ Checklist ngày'],
  ['/admin/layout', '🗺️ Layout cửa hàng'],
];

export default function AdminLayout() {
  return (
    <RequireStaff>
      <div className="admin-wrap">
        <aside className="admin-side">
          <Link to="/" className="brand">🌊 LiNT Admin</Link>
          {MENU.map(([to, label, end]) => (
            <NavLink key={to} to={to} end={!!end}>{label}</NavLink>
          ))}
        </aside>
        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </RequireStaff>
  );
}
